export default __webpack_public_path__ + "static/SRUS P239 - Especification Del Producto y Datos Técnicos-62678abcb0d41d6e6bd07356085f67c2.pdf";